/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Input.Gamepad.Configs
 */

module.exports = {

    DUALSHOCK_4: require('./Sony_PlayStation_DualShock_4'),
    SNES_USB: require('./SNES_USB_Controller'),
    XBOX_360: require('./XBox360_Controller')

};



//////////////////
// WEBPACK FOOTER
// ./input/gamepad/configs/index.js
// module id = 781
// module chunks = 0